import { render } from "./AppHeaderMember.vue?vue&type=template&id=789d27b2&scoped=true"
import script from "./AppHeaderMember.vue?vue&type=script&lang=js"
export * from "./AppHeaderMember.vue?vue&type=script&lang=js"

import "./AppHeaderMember.vue?vue&type=style&index=0&id=789d27b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\acer1\\Desktop\\TTT-Member\\Partner\\GOODLUCK711\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789d27b2"]])

export default __exports__